import React from 'react';
import {marginBottom, marginLeft, marginTop} from "../../common/script";
import {Row, Col} from "antd";

export default class DigitalPlatFormPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemList: [{
                img: 'images/ic_index_1.png',
                title: 'Supplier Management',
            }, {
                img: 'images/ic_index_2.png',
                title: 'Inventory Management',
            }, {
                img: 'images/ic_index_3.png',
                title: 'International Transportation',
            }, {
                img: 'images/ic_index_4.png',
                title: 'Distribution Center',
            }, {
                img: 'images/ic_index_5.png',
                title: 'Customer  ',
            }]
        }
    }

    render() {
        return (<div>
            <div style={{position: 'relative'}} className={'flex-row width100p'}>
                <img src={'https://qiniu.mrcargo.com/zs_digital_banner.png'} alt={'zs_digital_banner'}
                     className={'width100p'}/>
                <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                    <span className={'colorfff'}>Digital Platform</span>
                </div>
            </div>
            <Row>
                <Col span={16} offset={4}>
                    {
                        this.titleView('Digital Platform', 'Our goal is that our customers can stay ahead of the disruption at retail, capture and share data across the entire value chain to enable smarter, faster and more effective decisions, ensuring business sustainability.')
                    }

                    <Row justify={'space-between'}>
                        {
                            this.state.itemList.map((item, index) => {
                                return this.itemView(item, index)
                            })
                        }
                    </Row>
                </Col>
            </Row>
            <div className={'width100p font-size32 flex-col colorfff text-center bg-grep-gradient'}
                 style={marginTop(9)}>
                <div className={'colorfff flex-row'} style={Object.assign(marginTop(7), marginBottom(7))}>
                   <div>Sincerely serve every piece of your goods!</div>
                   <img style={marginLeft(3)} src={'images/ic_flower.png'} alt={'ic_flower'}/>
                </div>
            </div>
            <Row>
                <Col span={16} offset={4} style={marginBottom(8)}>
                    {
                        this.titleView('Supply Chain Solution', 'Our supply chain solutions are all about helping our customers by delivering speed and efficiency across their global supply chains and enabling margin enhancement and innovation.')
                    }
                    <div className={'flex-row justify-center'} style={marginTop(5)}>
                        <img src={'https://qiniu.mrcargo.com/zs_digital_solution.png'}
                             alt={'zs_digital_solution'}/>
                    </div>
                </Col>
            </Row>
        </div>);
    }

    titleView(title, context) {
        return <div>
            <div className={'flex-row'} style={marginTop(12)}>
                <img src={'images/ic_electronic.png'} alt={'ic_electronic'}/>
                <div className={'font-size40 color1E170B font-weight400'} style={marginLeft(2)}>{title}</div>
            </div>
            <div style={marginTop(4)} className={'font-size24 color666666'}>{context}</div>
        </div>
    }

    itemView(item, index) {
        return <div style={itemView} className={'bg-fff'}>
            <img src={item.img} alt={item.img}/>
            <div style={Object.assign(marginBottom(6))}
                 className={'font-size14 color0D182B text-center font-weight400'}>{item.title}</div>
        </div>
    }
}


const itemView = {
    width: '228px',
    border: '1px solid #dfdfdf',
    borderRadius: '8px',
    marginTop: '24px',
}
